<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasFoodStatusType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasCustomer="true"
      :hasFoodMajorKind="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasTerminal="true"
      :hasFoodSupplier="isERP"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      isERP: window.localStorage["isERP"] == "true",
      items: [],
      pagination: {},
      columns: [
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "TerminalNumber" },
        { name: "TerminalName" },
        { name: "TradeNumber" },
        { name: "TradeType" },
        { name: "TradeMemo" },
        { name: "Qty" },
        { name: "Price" },
        { name: "Total" },
        { name: "Unit" },
        { name: "Memo" },
      ],
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getFoodSaleDetail(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getFoodSaleDetail(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printFoodSaleDetail(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getFoodSaleDetail(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
